export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1C1C1C] mb-6 font-['Playfair_Display']">
              About Terra Construction
            </h2>
            
            <p className="text-lg text-[#1C1C1C]/80 mb-6 leading-relaxed">
              With years of expertise in landscape construction and design, we specialize in creating luxury outdoor living spaces 
              that seamlessly blend functionality with natural beauty. Our innovative approach combines traditional craftsmanship 
              with cutting-edge 3D visualization technology.
            </p>
            
            <p className="text-lg text-[#1C1C1C]/80 mb-8 leading-relaxed">
              We are committed to quality, clear communication, and bringing your vision to life through detailed design concepts 
              and professional construction. Every project is a testament to our dedication to excellence and innovation.
            </p>

            <div className="grid sm:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#4B6043] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-award-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-[#1C1C1C] mb-2">Quality</h3>
                <p className="text-sm text-[#1C1C1C]/70">Premium materials and superior craftsmanship</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#4B6043] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-chat-3-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-[#1C1C1C] mb-2">Communication</h3>
                <p className="text-sm text-[#1C1C1C]/70">Clear updates throughout your project</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#4B6043] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-lightbulb-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-[#1C1C1C] mb-2">Innovation</h3>
                <p className="text-sm text-[#1C1C1C]/70">3D visualization and modern design</p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/f93d48f1419f4c68f20bbda738a4241b/788643aacdf21c2ecc2916a90a28260c.png"
                alt="Terra Landscape Design Team"
                className="w-full h-[500px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            
            {/* Floating stats card */}
            <div className="absolute -bottom-8 -left-8 bg-white rounded-xl shadow-xl p-6 border border-[#D9C5A0]/20">
              <div className="flex items-center space-x-4">
                <div className="text-center">
                  <div className="text-2xl font-bold text-[#4B6043]">100+</div>
                  <div className="text-sm text-[#1C1C1C]/70">Projects</div>
                </div>
                <div className="w-px h-12 bg-[#D9C5A0]"></div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-[#4B6043]">3+</div>
                  <div className="text-sm text-[#1C1C1C]/70">Years</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
